module.exports = __webpack_public_path__ + "img/noParty.ad492a29.png";